import { Enums } from '@bode-canada/core';
import ServerlessApiService from '../ServerlessApiService';
import { ClaimOwnershipDto, GetHomeValueChartDto, PropertyOwnershipDto } from '@/types/property-ownership';
import { GetHomeownerDashboardDto } from '@/types/homeowner-dashboard';

const { ServerlessApiPathEnum, PropertyOwnershipApiPathEnum, HomeownerChartTypeEnum } = Enums;

export default class PropertyOwnershipApiService {
  static BASE_URL = `${PropertyOwnershipApiPathEnum.PROPERTY_OWNERSHIP}/${ServerlessApiPathEnum.V1}`;

  static claimOwnership(propertyId: number, body: ClaimOwnershipDto): Promise<PropertyOwnershipDto> {
    return ServerlessApiService.post(`${PropertyOwnershipApiService.BASE_URL}/${propertyId}`, body);
  }

  static getHomeownerDashboardData(): Promise<GetHomeownerDashboardDto> {
    return ServerlessApiService.get(`${PropertyOwnershipApiService.BASE_URL}/${PropertyOwnershipApiPathEnum.DASHBOARD}`);
  }

  static getHomeValueChart(): Promise<GetHomeValueChartDto> {
    return ServerlessApiService.get(`${PropertyOwnershipApiService.BASE_URL}/${PropertyOwnershipApiPathEnum.DASHBOARD}/${HomeownerChartTypeEnum.HOME_VALUE}`);
  }
}
